// extracted by mini-css-extract-plugin
export default {"Details":"Tips-module__Details--uvtvp","OpenLastItem":"Tips-module__OpenLastItem--NKrNU"};